import { Link } from 'react-router-dom';
import epityhontesData from '../data/epityhontes.json';

interface Student {
  name: string;
  department: string;
  university: string;
}

const students: Student[] = epityhontesData;

export default function Epityhontes() {
  return (
    <>
      <section className="page-hero">
        <div className="wrap">
          <Link to="/" className="back-link">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M19 12H5M12 19l-7-7 7-7"/>
            </svg>
            Αρχική
          </Link>
          <p></p>
          <p className="eyebrow paper">Πανελλήνιες Εξετάσεις</p>
          <h1>Οι επιτυχόντες μας</h1>
          <p className="page-sub">Μαθητές που πέτυχαν την εισαγωγή τους σε ΑΕΙ μέσω του φροντιστηρίου μας.</p>
        </div>
      </section>

      <section className="sec results-section">
        <div className="wrap">
          <div className="results-table-wrap">
            <table className="results-table">
              <thead>
                <tr>
                  <th>Όνομα</th>
                  <th>Τμήμα</th>
                  <th>Πανεπιστήμιο</th>
                </tr>
              </thead>
              <tbody>
                {students.map((student, index) => (
                  <tr key={index}>
                    <td data-label="Όνομα">{student.name}</td>
                    <td data-label="Τμήμα">{student.department}</td>
                    <td data-label="Πανεπιστήμιο">{student.university}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="results-count">
            <strong>{students.length}</strong> επιτυχόντες
          </div>
        </div>
      </section>
    </>
  );
}
